import { atom } from 'jotai';
import cuid from 'cuid';
import { TargetItem } from '../types';

const listLoadReplyAtom = atom<string>(cuid());

const popupReplyAtom = atom<{
  show: boolean;
  reply_id: string | null;
  parent_id: string;
  target: Omit<TargetItem, '_id' | 'product_id'>;
}>({
  show: false,
  reply_id: null,
  parent_id: '',
  target: {
    title: '',
    handle: '',
  },
});

export { listLoadReplyAtom, popupReplyAtom };
